import type React from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import { Stack } from '@mui/material';
import type { NavigationButtonsController } from './NavigationButtons.controller';
import { TYPES } from '@/engine/ioc';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export const NavigationButtons: React.FC = observer(() => {
  const approveController = useInjection<NavigationButtonsController>(TYPES.NavigationButtonsController);
  return (
    <Container>
      <Stack direction="row" spacing={2} justifyContent="center">
        <StyledButton
          data-testid="backBtn"
          data-guide-id="backBtn"
          variant="outlined"
          disabled={approveController.isFirstView}
          size="large"
          onClick={(): void => approveController.prevView()}
        >
          BACK
        </StyledButton>
        {!approveController.isLastView && (
          <StyledButton
            variant="contained"
            color="success"
            disabled={!approveController.isNextViewEnabled()}
            size="large"
            data-testid="nextBtn"
            data-guide-id="nextBtn"
            onClick={(): void => approveController.nextView()}
            endIcon={<ArrowForwardIcon />}
          >
            NEXT
          </StyledButton>
        )}
      </Stack>
    </Container>
  );
});

const StyledButton = styled(Button)`
  @media (width < 100rem) {
    font-size: 0.8rem;
    padding: 0.5em 2em;
  }
`;

const Container = styled.div`
  overflow: hidden;
  grid-area: approve;
  text-align: center;
  padding-top: 1.5em;

  @media (width < 100rem) {
    padding-top: 1em;
  }
`;
